<template>
  <div id="app">
    <p class="levelteamTitle">{{level.name}}</p>
    <div class="firstlevelteam" v-for="(item,index) in levelList" :key="index">
      <div class="team_left">
        <img :src="item.head_image" alt="">
        <div class="team_left_L">
          <span>{{item.nick_name}}</span>
          <img src="../assets/img/gril.png" alt="">
        </div>
      </div>
      <div class="team_right">
        ${{item.coin}}
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        level: [] ,//获取当前等级的数据
        levelList:[]//根据等级获取的数据
      }
    },
    created: function() {
      document.title =this.$t('column.My_team')
      this.levelteam();
    },
    methods: {
      levelteam() {
        const type = this.$route.params && this.$route.query.id;
        const token = this.$route.query.token
        const lang = localStorage.getItem('lang')
        axios.post(this.baseUrlApi + this.baseUrlPath +
          "?ctl=invite_vue&act=subordinate&token="+token+"&type="+type+"&language="+lang).then(
          res => {
            this.level = res.data.data;
            this.levelList = res.data.data.list;
            console.log("返回数据等级:", res.data.data);
          }).catch((res) => {
          console.log("请求失败");
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/firstlevelteam.vue